import { Box, Button, Divider, HStack, Input, Text } from '@chakra-ui/react';
import React, { useContext, useEffect, useState } from 'react';
import { CartContext } from '../../../context/cart';
import useCartStore from '../../../store/cartStore';
import useStore from '../../../store/store';
import { MdLocationOn } from 'react-icons/md';

export const AddressSection = () => {
  const { location, setOrderDetail, activeStep, setActiveStep } =
    useContext(CartContext);
  const { setIsLocationOpen } = useCartStore();
  const { user } = useStore();
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [addressType, setAddressType] = useState('');
  const [mainAddress, setMainAddress] = useState('');

  useEffect(() => {
    if (user) {
      if (user.email && !email) setEmail(user.email);
      if (user.phone && !phone) {
        // Remove +91 or any non-digits for the 10-digit field
        const cleanPhone = String(user.phone).replace(/\D/g, '').slice(-10);
        setPhone(cleanPhone);
      }
    }
  }, [user, email, phone]);

  useEffect(() => {
    if (location) {
      setMainAddress(location);
    }
  }, [location]);

  const changeButtonColor = buttonId => {
    const buttons = ['Work', 'Home', 'Others'];
    buttons.forEach(id => {
      const button = document.getElementById(id);
      if (button) {
        button.style.backgroundColor = 'rgba(0, 0, 0, 0.1)';
      }
    });

    const clickedButton = document.getElementById(buttonId);
    if (clickedButton) {
      clickedButton.style.backgroundColor = 'rgb(207, 255, 207)';
      setAddressType(buttonId);
    }
  };

  const handlePhoneChange = e => {
    const val = e.target.value.replace(/\D/g, '').slice(0, 10);
    setPhone(val);
  };

  const locationChangeHandler = () => {
    setActiveStep(activeStep - 1);
    setIsLocationOpen(true);
  };

  useEffect(() => {
    setOrderDetail(orderDetail => ({
      ...orderDetail,
      email: email,
      phone: phone,
      mainAddress: mainAddress,
      address: {
        addressType,
        secondaryAddress: location,
      },
    }));
  }, [email, phone, location, addressType, mainAddress, setOrderDetail]);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        flex: 7,
        width: '100%',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDir: 'column',
          gap: '30px',
          width: '100%',
        }}
      >
        <Box
          sx={{
            border: '1px solid rgba(0, 0, 0, 0.3)',
            display: 'flex',
            flexDir: 'column',
            gap: '16px',
            p: '20px',
            py: '30px',
            pb: '40px',
            borderRadius: '20px',
          }}
        >
          <Box
            display={'flex'}
            flexDirection={['row', 'row', 'row', 'row']}
            gap={['16px', '16px', '20px', '20px']}
            alignItems={'center'}
            justifyContent={'space-between'}
            flexWrap={['wrap', 'wrap', 'nowrap', 'nowrap']}
          >
          <Box
            display={'flex'}
            flexDirection={['row', 'row', 'row', 'row']}
            gap={['16px', '16px', '20px', '20px']}
            alignItems={'center'}
            justifyContent={'space-between'}
            width="100%"
          >
            <HStack spacing={5} alignItems="center" flex={1}>
              <MdLocationOn size={50} color="black" />
              <Box
                sx={{
                  display: 'flex',
                  flexDir: 'column',
                  gap: '2px',
                }}
              >
                <Text
                  sx={{
                    color: 'black',
                    fontSize: '20px',
                    fontWeight: 600,
                  }}
                >
                  {location?.split(',')[0]}
                </Text>
                <Text
                  sx={{
                    color: 'black',
                    fontWeight: 600,
                    fontSize: '14px',
                  }}
                >
                  {location?.split(',')?.slice(1)?.join(',')}
                </Text>
              </Box>
            </HStack>
            <Button
              variant={'outline'}
              borderRadius={'20px'}
              padding={'5'}
              colorScheme="teal"
              onClick={locationChangeHandler}
            >
              Change
            </Button>
          </Box>
          </Box>
          
          <Divider />

          <Box
            sx={{
              display: 'flex',
            }}
            width={'100%'}
          >
            <Text
              width={'100%'}
              px={'4'}
              py={'1'}
              backgroundColor={'darkred'}
              borderRadius={'20'}
              color={'white'}
              textAlign={'center'}
            >
              Phlebotomist will visit at this address for sample collection
            </Text>
          </Box>

          <Box
            display={'flex'}
            gap={['16px', '16px', '10px', '10px']}
            flexDirection={['column', 'column', 'row', 'row']}
          >
            <Input
              sx={{
                border: '1px solid rgba(0, 0, 0, 0.3)',
                color: 'black',
                fontWeight: 600,
                flex: 1
              }}
              placeholder="House No. / Building Name / Street Address *"
              value={mainAddress}
              onChange={(e) => setMainAddress(e.target.value)}
              required={true}
            />
            
            <HStack justifyContent={'space-between'}>
              {['Home', 'Work', 'Others'].map((type) => (
                <Button
                  key={type}
                  id={type}
                  sx={{
                    display: 'flex',
                    gap: '10px',
                    px: '20px',
                    borderRadius: '20px',
                    fontSize: '13px',
                    bg: addressType === type ? 'rgb(207, 255, 207)' : 'rgba(0,0,0,0.1)',
                  }}
                  onClick={() => changeButtonColor(type)}
                >
                  <Text>{type}</Text>
                </Button>
              ))}
            </HStack>
          </Box>
        </Box>
        <Box
          sx={{
            border: '1px solid rgba(0, 0, 0, 0.3)',
            display: 'flex',
            flexDir: 'column',
            gap: '15px',
            p: '20px',
            py: '30px',
            pb: '40px',
            borderRadius: '20px',
          }}
        >
          <Text
            sx={{
              color: 'black',
              fontWeight: 600,
              fontSize: '18px',
            }}
          >
            Updates/Reports will be sent on
          </Text>
          <Box
            sx={{
              display: 'flex',
              gap: '30px',
            }}
          >
            <Input
              sx={{
                border: '1px solid rgba(0, 0, 0, 0.3)',
                color: 'black',
                fontWeight: 600,
              }}
              placeholder="Email *"
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required={true}
            />
            <Input
              sx={{
                border: '1px solid rgba(0, 0, 0, 0.3)',
                color: 'black',
                fontWeight: 600,
              }}
              placeholder="Phone Number *"
              type="tel"
              value={phone}
              onChange={handlePhoneChange}
              required={true}
              maxLength={10}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
